import { render, staticRenderFns } from "./Directionality.vue?vue&type=template&id=2c2f499c&scoped=true&"
import script from "./Directionality.vue?vue&type=script&lang=js&"
export * from "./Directionality.vue?vue&type=script&lang=js&"
import style0 from "./Directionality.vue?vue&type=style&index=0&id=2c2f499c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f499c",
  null
  
)

export default component.exports